import { render, staticRenderFns } from "./LandingRegionGroup.vue?vue&type=template&id=6aaef378&scoped=true"
import script from "./LandingRegionGroup.vue?vue&type=script&lang=js"
export * from "./LandingRegionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaef378",
  null
  
)

export default component.exports